import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { SplitSection } from '../layout/SplitSection';
import { cognocracyMethods, cognocracyPapers, type ProjectMaterial } from '../../data/initiatives';
import { fadeUp } from '../../utils/motion';

/** Papers and assessment methods behind the project, each with its current status. */
export function ProjectMaterials() {
  return <SplitSection title="Papers and methods behind Cognocracy" intro={['The documents and assessment methods the project depends on.', 'None of the papers are published yet. Each is listed with its current status and will link to the full text once it is released.']} data-id="element-1877" data-mp="2mbolgbzxopfz">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-x-10" data-id="element-1878" data-mp="2r4q14m7yst0m">
        <MaterialList heading="Papers" items={cognocracyPapers} data-id="element-1879" data-mp="352ep42xbwg9w" />
        <MaterialList heading="Assessment methods" items={cognocracyMethods} data-id="element-1880" data-mp="3044rzms1n5ln" />
      </div>
    </SplitSection>;
}
type MaterialListProps = {
  heading: string;
  items: ProjectMaterial[];
};
function MaterialList({
  heading,
  items
}: MaterialListProps) {
  return <motion.div {...fadeUp} data-id="element-1881" data-mp="x4l8h9w4r4h7">
      <h3 className="font-heading font-bold text-xl text-ink-dark mb-4" data-id="element-1882" data-mp="x5wc99pksc8b">{heading}</h3>
      <ul aria-label={heading} className="border-t border-line" data-id="element-1883" data-mp="12591g13x5ve2">
        {items.map(item => <li key={item.title} className="border-b border-line" data-id="element-1884" data-mp="162n7xl07tp2d">
            <a href={item.href} className="group flex items-start gap-4 py-6" data-id="element-1885" data-mp="1b31fz31tgz0e">
              <span className="flex-1" data-id="element-1886" data-mp="1g25p5toqqwqq">
                <span className="flex flex-wrap items-center gap-x-3 gap-y-1.5" data-id="element-1887" data-mp="1g1307razb4dg">
                  <span className="font-heading font-bold text-lg text-ink-dark group-hover:text-navy transition-colors duration-150" data-id="element-1888" data-mp="1kuyryc0nfv06">
                    {item.title}
                  </span>
                  <span className="text-xs font-semibold text-navy border border-navy/20 bg-surface-muted rounded-md px-2.5 py-1 whitespace-nowrap" data-id="element-1889" data-mp="1tvn7jb5oy3f6">
                    {item.status}
                  </span>
                </span>
                <span className="mt-1.5 block text-ink-muted leading-relaxed" data-id="element-1890" data-mp="3uuh214414iq9">{item.summary}</span>
              </span>
              <ArrowRight size={18} aria-hidden="true" className="mt-1 shrink-0 text-teal transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-1891" data-mp="8gyybas5ro0z" />
            </a>
          </li>)}
      </ul>
    </motion.div>;
}